import { IAlarmCentralProps } from '../../../../../services/AlarmCentralService/types';
import { useEffect, useState } from 'react';
import {
  useArmPhysicalByPartitionAlarmCentral,
  useDisarmPhysicalByPartitionAlarmCentral,
} from '../../../../../services/AlarmCentralService/Physical/hooks/useMutation';
import { AlarmCentralEndpoint } from '../../../../../services/AlarmCentralService/enums';
import AlarmCentralPartitionCard from '../../_components/AlarmCentralPartitionCard';
import { Grid2 } from '@mui/material';
import { IAlarmCentralVettiStatusProps } from '../../../../../services/AlarmCentralService/Physical/Vetti/types';

interface AlarmCentralPhysicalVettiPartitionsProps {
  status: IAlarmCentralVettiStatusProps;
  alarmCentral: IAlarmCentralProps;
}

const AlarmCentralPhysicalVettiPartitions = ({
  status,
  alarmCentral,
}: AlarmCentralPhysicalVettiPartitionsProps) => {
  const [isLoadingPartition, setIsLoadingPartition] = useState<boolean[]>([]);
  const {
    mutateAsync: mutateArmPhysicalByPartitionAlarmCentral,
    isLoading: isLoadingArmPhysicalByPartitionAlarmCentral,
  } = useArmPhysicalByPartitionAlarmCentral();
  const {
    mutateAsync: mutateDisarmPhysicalByPartitionAlarmCentral,
    isLoading: isLoadingDisarmPhysicalByPartitionAlarmCentral,
  } = useDisarmPhysicalByPartitionAlarmCentral();

  const onArmOrDisarm = (index: any, isArm: boolean) => {
    const loading = [...isLoadingPartition];
    loading[index] = true;
    setIsLoadingPartition(loading);

    if (isArm)
      mutateArmPhysicalByPartitionAlarmCentral({
        endpoint: AlarmCentralEndpoint.ALARM_CENTRAL_VETTI_ENDPOINT,
        partition: index + 1,
        id: alarmCentral.id,
      });
    else {
      mutateDisarmPhysicalByPartitionAlarmCentral({
        endpoint: AlarmCentralEndpoint.ALARM_CENTRAL_VETTI_ENDPOINT,
        partition: index + 1,
        id: alarmCentral.id,
      });
    }
  };

  useEffect(() => {
    const isLoading: boolean[] = [];
    for (let i = 0; i < alarmCentral.partitionQuantity; i++)
      isLoading[i] = false;
    setIsLoadingPartition(isLoading);
  }, [status]);

  return (
    <>
      {[...Array(alarmCentral.partitionQuantity)].map((_, index) => {
        const p = status.partitionsStatus[index];
        if (!p.isEnabled) return <></>;
        return (
          <Grid2 size={{ xs: 12 }} key={index}>
            <AlarmCentralPartitionCard
              onArmOrDisarm={() => onArmOrDisarm(index, p.isArmed ?? false)}
              isLoadingArmOrDisarm={isLoadingPartition[index]}
              isArmed={p.isArmed ?? false}
              account={alarmCentral.account}
              name={'Partição ' + (index + 1)}
              isVirtual={false}
            />
          </Grid2>
        );
      })}
    </>
  );
};

export default AlarmCentralPhysicalVettiPartitions;
